<template>
  <section id="service" class="n2-seccion n2-seccion--suave n4-servicios" v-if="S?.Mostrar && servicios.length">
    <div class="n2-contenedor">
      <div class="n4-cabeza n2-aparece">
        <span class="n4-cabeza__num" aria-hidden="true">{{ numero('service') }}</span>
        <h2 class="n4-titular"><NuxtLink :to="getLocalePath('/servicios')"><span v-html="S.Titulo?.Texto || tituloSeccion(NOTARIA, 'Servicios', $t)"></span></NuxtLink></h2>
        <div v-if="S.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(S.Descripcion.css)" v-html="S.Descripcion.Texto"></div>
      </div>

      <!-- Índice numerado, como el de una revista -->
      <ol class="n4-indice">
        <li v-for="(s, i) in servicios" :key="s.id ?? i" class="n4-indice__item n2-aparece">
          <span class="n4-indice__num">{{ String(i + 1).padStart(2, '0') }}</span>
          <div class="n4-indice__cuerpo">
            <h3><NuxtLink :to="getLocalePath('/servicios/' + s.Slug) + '?from=home'">{{ s.Titulo }}</NuxtLink></h3>
            <p>{{ textoPlano(s.Extracto || s.Subtitulo || s.Contenido, 160) }}</p>
          </div>
          <img v-if="s.Imagen" class="n4-indice__foto" :src="imagenIDtoSRC(s.Imagen)" alt="" loading="lazy" />
          <div class="n4-indice__acciones">
            <NuxtLink v-if="acceso.visible('servicios') && acceso.tramiteDeServicio(s)" :to="acceso.enlace('servicios', acceso.tramiteDeServicio(s))"
              class="n2-boton n2-boton--acento">{{ tSolicitud('Hacerlo online') }}</NuxtLink>
            <NuxtLink :to="getLocalePath('/servicios/' + s.Slug) + '?from=home'" class="n4-indice__flecha" :aria-label="tSolicitud('Más información') + ': ' + s.Titulo">→</NuxtLink>
          </div>
        </li>
      </ol>

      <div v-if="S.ShowButton && S.Button?.Texto" class="n2-centrado">
        <NuxtLink class="n2-boton n2-boton--linea" :to="getLocalePath('/servicios')">{{ S.Button.Texto }}</NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, alineacionTexto } from '../../composables/useNotaria2'
import { useSumario } from '../../composables/useNotaria4'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()
const { numero } = useSumario()

// Panel: Inicio → Servicios y los servicios marcados "Mostrar en inicio"
const S = computed(() => NOTARIA.value?.Theme?.Home?.Servicios)
const servicios = computed(() => (NOTARIA.value?.Servicios ?? []).filter(s => s.Publicado && s.MostrarHome))
</script>
